/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface QueueJob
 */
export interface QueueJob  {
    /**
     * 
     * @type {string}
     * @memberof QueueJob
     */
    _function?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueJob
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueJob
     */
    timestamp?: string;
}

/**
 * Check if a given object implements the QueueJob interface.
 */
export function instanceOfQueueJob(value: object): value is QueueJob {
    return true;
}

export function QueueJobFromJSON(json: any): QueueJob {
    return QueueJobFromJSONTyped(json, false);
}

export function QueueJobFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueueJob {
    if (json == null) {
        return json;
    }
    return {
        
                  '_function': json['function'] == null ? undefined : json['function'],
                  'identifier': json['identifier'] == null ? undefined : json['identifier'],
                  'timestamp': json['timestamp'] == null ? undefined : json['timestamp'],
    };
}

export function QueueJobToJSON(json: any): QueueJob {
    return QueueJobToJSONTyped(json, false);
}

export function QueueJobToJSONTyped(value?: QueueJob | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'function': value['_function'],
        'identifier': value['identifier'],
        'timestamp': value['timestamp'],
    };
}


